import { UserRecord, UserRecordListPartner, UserRecordMinimal } from '@navio/nsdk';
import { UserListItem } from 'noddi-types';

type AnyUser =
  | { name: string }
  | { firstName: string; lastName: string }
  | UserRecordMinimal
  | UserRecord
  | UserListItem
  | UserRecordListPartner;

/** What `getUserDisplayName` returns when the record carries no name to show. */
export const UNKNOWN_USER_NAME = '-';

export function getUserDisplayName(user: AnyUser | null | undefined): string {
  if (!user) {
    return UNKNOWN_USER_NAME;
  }

  if ('name' in user && user.name) {
    return user.name;
  }

  if ('firstName' in user && 'lastName' in user) {
    return `${user.firstName} ${user.lastName}`;
  }

  return UNKNOWN_USER_NAME;
}

export function getUserSelectOptionLabel(
  user: AnyUser & { name: string; email?: string | null; phoneNumber?: string | null },
  isNameDuplicate: boolean
): string {
  if (!isNameDuplicate) {
    return user.name;
  }
  const extra: string[] = [];
  if (user.email) {
    extra.push(user.email);
  }
  if (user.phoneNumber) {
    extra.push(user.phoneNumber);
  }
  return extra.length > 0 ? `${user.name} (${extra.join(' · ')})` : user.name;
}
